import React from 'react'
import { Col, Row } from 'react-angle-dashboard-components'

import { ReactComponent as CheckCircle } from './checkCircle.svg'
import { ReactComponent as XIcon } from '../../assets/X.svg'

const BooleanRow = ({ title, value }: { title: string; value: boolean }) => (
  <Row>
    <Col className="col-auto d-flex flex-column justify-content-center">
      {value ? (
        <CheckCircle />
      ) : (
        <XIcon
          fill="#DC3545"
          style={{
            width: 16,
            height: 16,
            marginLeft: 2,
            overflow: 'visible'
          }}
        />
      )}
    </Col>
    <Col className="pl-0">
      <div
        style={{
          color: '#212529',
          fontWeight: 500
        }}
      >
        {title}
      </div>
    </Col>
  </Row>
)

export default BooleanRow
